// Accept configured hexadecimal colors only; never infer a color from its reference.
export function colorSwatch(value) {
  const hex = (typeof value === 'string' ? value : value?.hex)?.trim();
  if (!/^#(?:[\da-f]{3}|[\da-f]{6})$/i.test(hex || '')) return null;
  return hex.length === 4 ? '#' + [...hex.slice(1)].map((c) => c + c).join('') : hex;
}
